import { merge } from "lodash";
import ReactApexChart from "react-apexcharts";
import Moment from "moment";
import { DownloadTableExcel } from "react-export-table-to-excel";
// material
import {
  Box,
  Card,
  CardHeader,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
} from "@mui/material";
import { fNumber } from "../../utils/formatNumber";
import { BaseOptionChart } from "../../components/charts";
import ReportWidgetSummary from "./reportedias/ReportWidgetSummary";
import Scrollbar from "../../components/Scrollbar";
import MovimientosHeader from "../../components/TableHeader/MovimientosHeader";
import { useRef, useState } from "react";
const TABLE_HEAD = [
  { id: "descripcion", label: "Descripcion", alignRight: false },
  { id: "tipo", label: "Tipo", alignRight: false },
  { id: "subtTipo", label: "Sub Tipo", alignRight: false },
  { id: "montoPago", label: "Monto de Pago", alignRight: false },
  { id: "fechaMovimiento", label: "Fecha de Movimiento", alignRight: false },
];
const ReporteEgresosDetalle = ({ datos, leyendas }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const tableRef = useRef(null);

  //Longitud
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  let result = [];
  let comisiones = [];
  let netoa = [];
  let delegados = [];
  let prueba = [];

  return (
    <>
      <Grid container spacing={3}>
        {/* <Grid item xs={12} sm={6} md={4}>
          <ReportWidgetSummary
            title="Ingreso Bruto"
            color="ingresoColor"
            total={ingresSubTotal}
            icon={"ant-design:dollar-circle-filled"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ReportWidgetSummary
            title="Ingreso Neto"
            color="ingresoNetoColor"
            total={ingresSubTotal - comisionesTotal}
            icon={"ant-design:dollar-circle-filled"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ReportWidgetSummary
            title="Comisiones"
            color="comisionesColor"
            total={comisionesTotal}
            icon={"ant-design:dollar-circle-filled"}
          />
        </Grid> */}

        <Grid item xs={12} md={6} lg={12}>
          <br />
          <Card>
            <CardHeader title={`${leyendas}`} />
            {/* <Box sx={{ mx: 3 }} dir="ltr">
              <ReactApexChart
                type="bar"
                options={chartOptions}
                series={CHART_DATA}
                height={364}
              />
            </Box> */}

            <Scrollbar>
              <DownloadTableExcel
                filename="Reporte ejecutivo de Fechas"
                sheet="reporte"
                currentTableRef={tableRef.current}
              >
                <button> Exportar a Excel </button>
              </DownloadTableExcel>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table ref={tableRef}>
                  <MovimientosHeader headLabel={TABLE_HEAD} />
                  <TableBody>
                    {datos
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row) => {
                        const {
                          descripcion,
                          MovimientosModel,
                          fechaEgreso,
                          CatEgresosModel,
                          detalleCuentasEgresosModel,
                        } = row;
                        return (
                          <TableRow
                            hover
                            key={MovimientosModel.id}
                            tabIndex={-1}
                          >
                            <TableCell>
                              {/* {
                                {
                                  1: "Matutino",
                                  2: "Vespertino",
                                  3: "Diurno",
                                }[turno]
                              } */}
                              {descripcion}
                            </TableCell>
                            <TableCell>{CatEgresosModel.clave}</TableCell>
                            <TableCell>
                              {detalleCuentasEgresosModel?.clave}
                            </TableCell>
                           
                            <TableCell>{MovimientosModel.monto}</TableCell>
                            <TableCell>
                              {Moment(fechaEgreso).format("DD-MMMM-YYYY")}
                            </TableCell>
                            {/*                            
                            <TableCell>{totalPermisos}</TableCell>
                            <TableCell>{totalFolios}</TableCell>
                            <TableCell>{folioIngreso}</TableCell>
                            <TableCell>
                              {" "}
                              {Moment(fechaTrabajo).format("dddd")}
                            </TableCell>
                            <TableCell>
                              {Moment(fechaTrabajo).format("DD-MMMM-YYYY")}
                            </TableCell>
                            <TableCell>
                              {Moment(fechaReporte).format("DD-MMMM-YYYY")}
                            </TableCell>

                            <TableCell>
                              {PersonasModel.nombre} {PersonasModel.apellidos}
                            </TableCell>
                            <TableCell>{PlazaModel.nombre}</TableCell>

                            <TableCell>$ {MovimientosModel.monto}</TableCell>
                            <TableCell>${MovimientosModel.comision}</TableCell>
                            <TableCell>${MovimientosModel.neto}</TableCell> */}
                          </TableRow>
                        );
                      })}
                    <TableRow>
                      {/* <TableCell colSpan={10}></TableCell>
                      <TableCell>$ {ingresSubTotal}</TableCell>
                      <TableCell>$ {comisionesTotal}</TableCell>
                      <TableCell>
                        $ {ingresSubTotal - comisionesTotal}
                      </TableCell> */}
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              page={page}
              count={datos.length}
              rowsPerPage={rowsPerPage}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default ReporteEgresosDetalle;
